<template>
    <ProductDetails/>
</template>
<script>
import ProductDetails from '../../components/products/ProductDetails';

export default {
  components: {
    ProductDetails,
  },
};
</script>
